import { Area, AreaChart, ResponsiveContainer, Tooltip } from 'recharts';
import React from 'react';
import { analyticsChartTheme } from 'util/chartUtils';
import CustomTooltip from '../../common/CustomToolTIp';
import { useLocalizedMessage } from 'util/useLocalizedMessage';

const PreparedChart = ({ data }) => {
  const t = useLocalizedMessage();
  return (
    <ResponsiveContainer className="rounded-bottom-right overflow-hidden" height={70}>
    <AreaChart
      data={[{ label: t('ui.widgets.lostOpportunities.queriesWithLowCTR.preparedChart.start'), total: 0 }, ...data]}
      margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
    >
      <defs>
        <linearGradient id="color7" x1="0" y1="0" x2="0" y2="1">
          <stop offset="5%" stopColor={analyticsChartTheme.warningFill} stopOpacity={1} />
          <stop offset="95%" stopColor={analyticsChartTheme.warningFill} stopOpacity={0.18} />
        </linearGradient>
      </defs>
      <Area
        type="natural"
        dataKey="total"
        strokeWidth={2}
        stackId="2"
        stroke={analyticsChartTheme.warning}
        fill="url(#color7)"
        fillOpacity={1}
      />
      <Tooltip
        content={<CustomTooltip />}
      />
    </AreaChart>
    </ResponsiveContainer>
  );
};

export default PreparedChart;
